import { useQuery } from '@apollo/client';
import { GET_REPORT_TYPES_QUERY } from '../operations';

const reportTypeLabels = {
  Corporate: 'Corporate',
  CountryArea: 'Country / Area',
  Asset: 'Asset',
};

export const useGetReportTypes = () => {
  const { data, loading, error } = useQuery(GET_REPORT_TYPES_QUERY);

  const reportTypes =
    data?.smartReportTypes?.map((type) => ({
      ...type,
      value: type?.name,
      label: reportTypeLabels[type?.name] || type?.name,
    })) || [];

  return {
    reportTypes,
    loading,
    error,
  };
};
